import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { customerWriteBody, mapCustomerRecordSnCodes } from './snCodeWire';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/**
 * 更新客戶（partial PATCH）。
 * `PATCH /crm/customer/{id}`；必帶 `updatedAt`。
 * 有傳 `addresses`＝merge-only（不可刪）；有傳 `contacts`＝replace-all；省略＝不改該子表。
 * **不送** status（啟停走 activate／deactivate）。
 *
 * @param {string} id
 * @param {object} payload — camelCase（含 updatedAt）
 */
export async function updateCustomer(id, payload) {
  const { data: raw } = await request.patch(
    `/crm/customer/${id}`,
    customerWriteBody(omitTopLevelId(payload)),
  );
  const parsed = parseVer4DetailResponse(raw);
  return { ...parsed, data: mapCustomerRecordSnCodes(parsed.data) };
}
